import { FC } from 'react';
import classes from './text.module.css';

export const Text: FC = ({ children }) => (
  <div className={classes.text}>{children}</div>
);
